module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card buttonsDiv"
  }, [_vm._l((_vm.months.length), function(monthNumber) {
    return _c('el-button', {
      class: {
        'el-button--primary': _vm.month == monthNumber - 1
      },
      on: {
        "click": function($event) {
          return _vm.getTableData(monthNumber - 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.months[monthNumber - 1]) + "\n                ")])
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "Wybierz zakres daty",
      "range-separator": ",",
      "format": "yyyy-MM-dd",
      "change": "loading"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), (!_vm.getExcelPermission()) ? _c('json-excel', {
    staticClass: "el-button el-button--default",
    attrs: {
      "data": _vm.jsonData,
      "fields1": _vm.json_fields1,
      "fields2": _vm.json_fields2,
      "name": ("raport_pitformat_" + _vm.lic + "_" + _vm.excelDate + ".xls")
    },
    on: {
      "onPrepareExportData": _vm.prepareExportData
    }
  }, [_vm._v("Eksport do excela\n                ")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('download-table', {
    attrs: {
      "columns-names": _vm.table1.names,
      "title": "Podsumowanie",
      "sub-title": "",
      "data": _vm.tableDataExeOnline,
      "columns": _vm.table1.columns,
      "sum": _vm.calculateSum(_vm.tableDataExeOnline)
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('download-table', {
    attrs: {
      "columns-names": _vm.table1.names,
      "title": "Instalacyjna",
      "sub-title": "",
      "data": _vm.tableDataExe,
      "columns": _vm.table1.columns,
      "sum": _vm.calculateSum(_vm.tableDataExe)
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('download-table', {
    attrs: {
      "columns-names": _vm.table1.names,
      "title": "Online",
      "sub-title": "",
      "data": _vm.tableDataOnline,
      "columns": _vm.table1.columns,
      "sum": _vm.calculateSum(_vm.tableDataOnline)
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39bd445f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/DownloadStats.vue
// module id = 440
// module chunks = 1